import { createApiClient } from "Network/ApiClient";
//api

export const RefillLimitDrugsAxiosInstance = createApiClient("RefillDrugs/");

